"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle forms
 *
 * @namespace
 * @memberOf txGs1Base.forms
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.forms = {};
_main_1.txGs1Base.forms.async = {
    bindInteractions: function () {
        $('body').on('submit', 'form[data-async="true"]', function (event) {
            event.preventDefault();
            var $form = $(this);
            var params = $form.serializeObject();
            params = $.extend({}, params, { 'type': '104' });
            $.ajax({
                url: $form.prop('action'),
                data: params,
                type: 'post',
                cache: false,
                success: function (data) {
                    $('.fancybox-inner > div').html(data);
                    $.eventEmitter.emit('contentUpdate');
                    if ($('.fancybox-inner .cart-action-success').length > 0) {
                        $.gs1_cart.updateCartButton();
                    }
                }
            });
        });
    },
    /**
     *
     */
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.forms.async.bindInteractions();
    }
};
exports.default = {};
